angular.module('unergie.main')
.factory('UserInfoContractReducer', (MetaWatcher) => {
    const INITIAL_STATE = {
        account: null,
        contractDrafts: [],
        currentContract: null,
        contractTabIndex: 0,
        rootView: {
            loadingAccount: false,
            loadingContractDraft: false,
            loadingContract: { isLoading: false, lastUpdate: null },
            loadingTab: false,
            accountError: null,
            contractDraftError: null,
        },
    }

    const rootReducer = function (state, action) {
        switch (action.type) {
            case 'GET_ACCOUNT_DONE':
                MetaWatcher.notif('POT_CHANGED', action.account)
                return _.assign({}, state, { account: action.account })
            case 'GET_CONTRACT_DRAFT_DONE':
                return _.assign({}, state, { contractDrafts: action.contractDrafts })
            case 'LOADING_CONTRACT_TAB':
                return _.assign({}, state, { contractTabIndex: action.index })
            case 'UPDATE_CONTRACT_TAB':
                return _.assign({}, state, { contractTabIndex: action.index })
            case 'UPDATE_ACCOUNT_CONTRACT':
                state.account.contractList.splice(_.findIndex(state.account.contractList, { id: action.contract.id }), 1, action.contract)
                return state
            default:
                return state
        }
    }

    const rootViewReducer = function (state, action) {
        switch (action.type) {
            case 'GET_ACCOUNT':
                return _.assign({}, state, { loadingAccount: true, accountError: null })
            case 'GET_ACCOUNT_DONE':
                return _.assign({}, state, { loadingAccount: false, accountError: null })
            case 'GET_ACCOUNT_FAIL':
                return _.assign({}, state, { loadingAccount: false, accountError: action.error })
            case 'GET_ACCOUNT_NONE':
                return _.assign({}, state, { loadingAccount: false })
            case 'GET_CONTRACT_DRAFT':
                return _.assign({}, state, { loadingContractDraft: true, contractDraftError: null })
            case 'GET_CONTRACT_DRAFT_DONE':
                return _.assign({}, state, { loadingContractDraft: false, contractDraftError: null })
            case 'GET_CONTRACT_DRAFT_FAIL':
                return _.assign({}, state, { loadingContractDraft: false, contractDraftError: action.error })
            case 'GET_CONTRACT':
                return _.assign({}, state, { loadingContract: { isLoading: true, lastUpdate: new Date() }, refreshTab: true })
            case 'GET_CONTRACT_DONE':
                return _.assign({}, state, { loadingContract: { isLoading: false, lastUpdate: new Date() }, refreshTab: true })
            case 'GET_CONTRACT_FAILED':
                return _.assign({}, state, { loadingContract: { isLoading: false, lastUpdate: new Date() }, refreshTab: true, contractDraftError: action.error })
            case 'REFRESH_TAB':
                return _.assign({}, state, { refreshTab: true })
            case 'REFRESH_TAB_DONE':
                return _.assign({}, state, { refreshTab: false })
            default:
                return state
        }
    }

    const currentContractReducer = function (state, action) {
        switch (action.type) {
            case 'SET_CURRENT_CONTRACT':
                return _.assign({}, action.contract)
            default:
                return state
        }
    }

    const reducer = function (state, action) {
        if (state == null) { state = INITIAL_STATE }
        return _.assign({}, rootReducer(state, action), {
            rootView: rootViewReducer(state.rootView, action),
            currentContract: currentContractReducer(state.currentContract, action),
        })
    }

    return {
        reducer,
    }
})
